export interface ChildDetails {
  allowedPeople: Guardian[];
  childCollectionOption: number;
  childStatementConfirmed: boolean;
}

export interface Guardian {
  familyName: string;
  otherNames: string;
  relationship: string;
  telephone: string;
}

export const DEFAULT_GUARDIAN = {
  familyName: '',
  otherNames: '',
  relationship: '',
  telephone: '',
};
